import React, { useState, useEffect } from 'react'
// import Button from '@material-ui/core/Button'
import MUIDataTable from 'mui-datatables'
import { ThemeProvider } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { getUsers } from 'src/app/slices/usersSlice'
import { getMuiThemeWithoutPadding } from '../../utils/TableStyle'
import {
  getDiscounts, deleteDiscount,
  //  downloadDiscounts
} from '../../app/slices/discountSlice'
import muiDefaultOptions from '../../constants/muiTableOptions'

export const AdminList = () => {
  const dispatch = useDispatch()
  const discounts = useSelector((state) => state.discounts.list)
    .filter((user) => user?.assignedTo?.role?.roleId === 9)
  const users = useSelector((state) => state.users.list).filter((user) => user?.role?.roleId === 9)
  const count = useSelector((state) => state.discounts.totalHits)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(muiDefaultOptions.rowsPerPage)
  // const [currentRole] = useState(roles.map((role) => role.roleId))
  // const [searchTerm] = useState(null)
  // const [allData] = useState([...discounts?.filter((discount) => discount?.assignedTo)])

  const assigneDiscount = discounts?.filter((discount) => discount?.assignedTo)

  useEffect(() => {
    dispatch(getDiscounts({
      after: page * rowsPerPage,
      first: rowsPerPage,
    }))

    dispatch(getUsers({
      roleIds: 9,
      full: true,
      // userName: searchTerm,
    }))
  }, [rowsPerPage, page])

  const handleDelete = (list) => {
    const data = list?.data?.map((item) => discounts[item.dataIndex].discountId)
    dispatch(deleteDiscount(data))
  }

  const getUserDiscount = (userId) => {
    return assigneDiscount?.find((discount) => +discount
      ?.assignedTo?.userId === +userId)
  }

  // const handleDownlaod = (url) => dispatch(downloadDiscounts(url))

  const COLUMNS = [
    {
      name: 'discountId',
      label: 'ردیف',
      options: {
        customBodyRender: (value) => {
          const index = users?.findIndex((user) => user?.discountId === value)
          return (
            <p>{index + 1}</p>
          )
        },
      },
    },
    {
      name: 'profile',
      label: 'نام و نام خانوادگی',
      options: {
        customBodyRender: (value) => (value ? `${value?.firstName} ${value?.lastName}` : null),
      },
    },
    {
      name: 'profile',
      label: 'شماره تماس',
      options: {
        customBodyRender: (value) => value?.phoneNumber,
      },
    },
    {
      name: 'userName',
      label: 'نام کاربری',
      options: {
        customBodyRender: (value) => value,
      },
    },
    {
      name: 'userId',
      label: 'کد تخفیف',
      options: {
        customBodyRender: (value) => {
          const code = getUserDiscount(value)
          return (
            <p>{code?.code}</p>
          )
        },
      },
    },
    {
      name: 'userId',
      label: 'تعداد',
      options: {
        customBodyRender: (value) => {
          const code = getUserDiscount(value)
          return (
            <p>{code?.maxUsedCount}</p>
          )
        },
      },
    },
    {
      name: 'userId',
      label: 'تعداد استفاده شده',
      options: {
        customBodyRender: (value) => {
          const code = getUserDiscount(value)
          return (
            <p>{code?.currentUsedCount}</p>
          )
        },
      },
    },
    {
      name: 'userId',
      label: 'میزان فروش',
      options: {
        customBodyRender: (value) => {
          const code = getUserDiscount(value)
          return (
            <p>{code?.totalSalePrice}</p>
          )
        },
      },
    },
  ]

  console.log('users', users)
  return (
    <ThemeProvider theme={getMuiThemeWithoutPadding}>
      <MUIDataTable
        data={users}
        columns={COLUMNS}
        options={{
          ...muiDefaultOptions,

          rowsPerPage,
          page,
          count,

          serverSide: true,
          filter: false,
          print: false,
          download: false,
          search: false,

          rowHover: true,
          selectableRows: 'none',
          onRowsDelete: (selectedRows) => handleDelete(selectedRows),
          searchable: false,
          onTableChange: (action, state) => {
            switch (action) {
              case 'changePage': {
                setPage(state.page)
                break
              }
              case 'changeRowsPerPage': {
                setRowsPerPage(state.rowsPerPage)
                break
              }
              default: {
                return null
              }
            }
            return null
          },
        }}
      />
    </ThemeProvider>
  )
}

export default AdminList
